import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { UnidadeUnificadaResponse } from "../typings";

function useUnidadesUnificadas(params: {
  page: number;
  search?: string;
  limit?: number;
}) {
  return useQuery([`/v1/unidades-unificadas`, params], async () => {
    const { data } = await axios.get<PaginateResult<UnidadeUnificadaResponse>>(
      `/v1/unidades-unificadas`,
      {
        params,
      }
    );

    return data;
  });
}

export default useUnidadesUnificadas;
